export default class ChatAppExtensions {
    static getAPI(chatApp, chatAppProps) {      
        let isMobile = chatAppProps.mobile;
        return {
            setExtension: chatApp.setExtension.bind(chatApp),
            sendActivity: activity => { chatApp.state.store.dispatch(activity) },
            isMobile: () => isMobile
        }
    }
}